<ng-container *ngIf="user$ | async; let user">
    <button (click)="startRecorder(user.canRecordUnlimited())" type="button" class="audio-record" mat-menu-item>
        <mat-icon>mic</mat-icon>
        <span i18n>Record audio</span>
    </button>
</ng-container>
